module.exports = __webpack_public_path__ + "img/CHINA.5da47471.jpg";